import { MapPin } from "lucide-react";
import { Reveal, Overline } from "./shared";

const COMMUNES = ["Sion", "Savièse", "Grimisuat", "Ayent", "Ardon", "Conthey", "Vétroz", "Grône", "Icogne", "Lens", "Sierre", "Salquenen", "Monthey", "Martigny"];

export const ZoneIntervention = ({ dark = false }) => (
  <section className={`${dark ? "bg-nuit" : "bg-brume"} py-20 lg:py-28`} data-testid="zone-intervention">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <Overline light={dark}>Zone d'intervention</Overline>
          <h2 className={`font-display mt-4 text-3xl font-medium leading-tight tracking-tight sm:text-4xl ${dark ? "text-white" : "text-nuit"}`}>
            Une entreprise locale, basée à Sion
          </h2>
          <p className={`mt-6 text-base leading-relaxed ${dark ? "text-white/65" : "text-nuit/65"}`}>
            Rosset Conciergerie &amp; Services intervient à Sion, dans tout le Valais central
            et en Bas-Valais, de Monthey à Martigny. La proximité permet des passages réguliers,
            une vraie réactivité et un interlocuteur qui connaît les immeubles dont il s'occupe.
          </p>
          <p className={`mt-4 text-sm leading-relaxed ${dark ? "text-white/45" : "text-nuit/50"}`}>
            Votre commune ne figure pas dans la liste ? Contactez-nous : d'autres interventions
            sont possibles dans la région selon la nature du mandat.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex flex-wrap content-start gap-2">
            {COMMUNES.map((c) => (
              <span
                key={c}
                className={`flex items-center gap-2 px-4 py-2.5 text-xs font-semibold uppercase tracking-[0.12em] ${
                  dark ? "border border-lagoon/25 text-lagoon" : "bg-white text-petrole shadow-sm"
                }`}
              >
                <MapPin className="h-3.5 w-3.5" /> {c}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
